import { render, staticRenderFns } from "./exams.vue?vue&type=template&id=24449233&scoped=true"
import script from "./exams.vue?vue&type=script&lang=ts"
export * from "./exams.vue?vue&type=script&lang=ts"
import style0 from "./exams.vue?vue&type=style&index=0&id=24449233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24449233",
  null
  
)

export default component.exports